<template>
  <component v-if="!loading" :is="app" />
</template>

<script>
import { getUrlParam } from "@utils/url";
import App from "@apps/App";
import Icon from "@apps/Icon";
import Activities from "@apps/Activities";
import BigScreen from "@apps/BigScreen";

export default {
  name: "Activities",
  components: {
    [App.name]: App,
    [Icon.name]: Icon,
    [Activities.name]: Activities,
    BigScreen,
  },
  data() {
    return {
      loading: true,
      app: "",
    };
  },
  created() {
    const suitId = getUrlParam("suit_id");
    const activeId = getUrlParam("active_id");
    const kaPos = getUrlParam("ka_pos");
    const page = getUrlParam("page");
    //
    if (page == "1") {
      this.app = "BigScreen";
    } else {
      //兼容之前的
      if (suitId) {
        this.app = "app";
      }
      if (activeId) {
        this.app = kaPos ? "KaActivities" : "icon";
      }
    }
    console.log("this.app:", this.app);
  },
  mounted() {
    this.loading = false;
  },
};
</script>
